import { AccountLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { ProfilePreviewTooltipFragment } from "../profile/ProfilePreviewTooltip/ProfilePreviewTooltip.fragment"

export const ActivityFromFragment = graphql(
  `
    fragment ActivityFrom on Activity {
      __typename
      from {
        ...AccountLockup
        ...ProfilePreviewTooltip
      }
    }
  `,
  [AccountLockupFragment, ProfilePreviewTooltipFragment],
)
